import React from 'react'
import { Button, Container } from '@mui/material'
import WholesaleRegistrationForm, { WholesaleRegistrationFormData } from './WholesaleRegistrationForm'
import { SITE_NAME } from '../../../../constants'
import { ErrorFragment } from '@graphql/fragments/__generated__/Error.generated'
import { Trans, useTranslation } from 'react-i18next'

interface Props {
  onSubmit(values: WholesaleRegistrationFormData): Promise<void>
  errors: ErrorFragment[]
  isAuthenticated: boolean
  hasWholesaleApp: boolean
  userEmail?: string
  openSignInForm(): void
}

const Page: React.FC<Props> = ({ onSubmit, errors, isAuthenticated, hasWholesaleApp, userEmail, openSignInForm }) => {
  const { t } = useTranslation()
  return (
    <div style={{ backgroundColor: '#f2eeea' }}>
      <div className='md:py-20' style={{ minHeight: 'calc(100vh - 534px)' }}>
        <Container className='bg-white rounded-2xl' maxWidth='lg'>
          <div className='px-0 md:px-60 lg:px-160 py-30'>
            <h2 className='my-30 uppercase font-semibold text-3xl text-center leading-normal'>
              <Trans i18nKey='wholesale.accountApp'>
                Wholesale Account
                <br />
                Application
              </Trans>
            </h2>
            <div className='mb-20 text-center'>
              <p className='text-xl leading-normal'>
                {isAuthenticated && hasWholesaleApp && (
                  <span>{t('alreadyHasWholesaleApp', 'You already have a wholesale account application.')}</span>
                )}
                {isAuthenticated && !hasWholesaleApp && (
                  <Trans
                    i18nKey='wholesale.accountAppDescription'
                    defaults={`Thank you so much for your interest in our brands. <br />Please complete the form below to apply for your wholesale account on {{siteName}}. <br />We’ll get back to you as soon as we can!`}
                    values={{ siteName: SITE_NAME }}
                    components={{ br: <br /> }}
                  />
                )}
                {!isAuthenticated && (
                  <span>
                    <span className='block mb-15'>{t('signInToYourAccount', 'Sign in to your account.')}</span>
                    <Button variant='contained' color='secondary' type='button' size='large' onClick={openSignInForm}>
                      Sign in
                    </Button>
                  </span>
                )}
              </p>
            </div>
            {isAuthenticated && !hasWholesaleApp && (
              <WholesaleRegistrationForm onSubmit={onSubmit} errors={errors} email={userEmail} />
            )}
          </div>
        </Container>
      </div>
    </div>
  )
}

export default Page
